import React from 'react';

import { TableContainer } from 'apps/auth/components/common/components/TableRow/styles';
import { TableRow } from 'apps/auth/components/common/components/TableRow/TableRow';
import { DangerouslyHtml } from 'apps/auth/components/common/DangerouslyHtml/DangerouslyHtml';
import { DiskButton } from 'apps/auth/components/common/DiskButton/DiskButton';
import FeeTextPopup from 'apps/auth/components/common/send/popups/FeeTextPopup';
import {
    DELIVERY_ALIPAY,
    DELIVERY_BANK_ACCOUNT,
    DELIVERY_BANK_CARD,
    DELIVERY_CASH,
    DELIVERY_HOME,
    DELIVERY_UNIONPAY_BANK_CARD,
    DELIVERY_UPI,
    DELIVERY_VISA_BANK_CARD,
    DELIVERY_WALLET,
    DELIVERY_WECHAT,
} from 'apps/auth/constants/Constants';
import { VIETNAM } from 'apps/auth/constants/WellKnownCountries';
import { getFormattedCardOrAccountNumber } from 'apps/auth/helpers/utils';

const PreCheckRow = ({ title, text }) => {
    return (
        <TableRow pseudoTable title={title}>
            {text}
        </TableRow>
    );
};

const PreCheckDetails = (props) => {
    const { preCheck, paymentForm, closeHandlerForPopup, messages, exchangeRatioText, toAccountValue, toCountry, recipientComponent, popupRef } = props;
    const { deliveryMethod, toPhoneNumber, nameTo, accountFrom, accountTo, toAddress, toBankName, toBankCountryName, toPickupNetwork } = preCheck;
    const isShowRecipient = nameTo && typeof nameTo === 'string' && nameTo.trim().length > 0;

    const getAccountToPrefix = {
        [DELIVERY_BANK_CARD]: messages.transferToCard,
        [DELIVERY_VISA_BANK_CARD]: messages.transferToCard,
        [DELIVERY_UNIONPAY_BANK_CARD]: messages.transferToCard,
        [DELIVERY_BANK_ACCOUNT]: messages.transferToAccount,
        [DELIVERY_WECHAT]: messages.transferToAccount,
        [DELIVERY_WALLET]: messages.transferToWallet,
        [DELIVERY_UPI]: messages.transferToWallet,
        [DELIVERY_ALIPAY]: messages.transferToWallet,
        [DELIVERY_CASH]: messages.transferToCash,
        [DELIVERY_HOME]: messages.deliveryHomeTitle,
    };
    const isTo = toPhoneNumber || toAccountValue;
    return (
        <TableContainer>
            <PreCheckRow title={messages.precheckAmountFee} text={preCheck.commission} />
            {preCheck.promoCode && <PreCheckRow title={messages.precheckPromocodeField} text={preCheck.promoCode} />}
            {preCheck.exchangeRate && <PreCheckRow title={messages.precheckAmountFxRate} text={preCheck.exchangeRate} />}
            {!preCheck.exchangeRate && exchangeRatioText && <PreCheckRow title={messages.precheckAmountFxRate} text={exchangeRatioText} />}
            {isShowRecipient && recipientComponent}
            {(deliveryMethod === DELIVERY_CASH || deliveryMethod === DELIVERY_HOME) && isTo && (
                <PreCheckRow title={messages.mobilePhone} text={`+${toPhoneNumber ? toPhoneNumber : toAccountValue}`} />
            )}
            <PreCheckRow
                title={messages.toBlock}
                text={`${getAccountToPrefix[deliveryMethod] ?? ''} ${accountTo ? getFormattedCardOrAccountNumber(accountTo, deliveryMethod) : ''}`}
            />
            {paymentForm.toInterac && <PreCheckRow title={messages.precheckProvider} text={messages.chequeRecipientInterac} />}
            {paymentForm.toHome && <PreCheckRow title={messages.toAddress} text={<DangerouslyHtml type="span" dangerouslyHtml={toAddress} />} />}
            {deliveryMethod !== DELIVERY_CASH && deliveryMethod !== DELIVERY_HOME && toBankName && (
                <PreCheckRow title={messages.chequeBlockBankHeader} text={`${toBankName} · ${toBankCountryName}`} />
            )}
            {deliveryMethod === DELIVERY_CASH && toBankName && (
                <TableRow
                    pseudoTable
                    title={toCountry.id === VIETNAM ? messages.chequeBlockBankForPickupHeader : messages.cashPickupHeader}
                    onClick={() => {
                        if (toPickupNetwork) {
                            popupRef?.current?.open(<FeeTextPopup popupRef={popupRef} text={toPickupNetwork} closeHandler={() => closeHandlerForPopup()} />);
                        }
                    }}
                >
                    <>
                        {toPickupNetwork ? (
                            <>
                                {toBankName}
                                <DiskButton type="button" iconName="info-rounded" size="small" marginRight="-8px" marginTop="-4px" raised={false} />
                            </>
                        ) : (
                            <>{toBankName}</>
                        )}
                    </>
                </TableRow>
            )}
            {paymentForm.description && (
                <TableRow
                    pseudoTable
                    title={paymentForm.description.indexOf(':') !== -1 ? paymentForm.description.split(':')[0] : paymentForm.description}
                    onClick={() => {
                        if (paymentForm.comment) {
                            popupRef?.current?.open(
                                <FeeTextPopup
                                    popupRef={popupRef}
                                    countryToId={toCountry.id}
                                    text={paymentForm.comment}
                                    isComment={true}
                                    deliveryMethod={paymentForm.deliveryMethod}
                                    closeHandler={() => closeHandlerForPopup()}
                                />,
                            );
                        }
                    }}
                >
                    {paymentForm.description.indexOf(':') !== -1 && (
                        <>
                            {paymentForm.description.split(':')[1]}
                            {paymentForm.comment && (
                                <DiskButton type="button" iconName="info-rounded" size="small" marginRight="-8px" marginTop="-4px" raised={false} />
                            )}
                        </>
                    )}
                    {paymentForm.description.indexOf(':') === -1 && (
                        <>
                            {paymentForm.description}
                            {paymentForm.comment && (
                                <DiskButton type="button" iconName="info-rounded" size="small" marginRight="-8px" marginTop="-4px" raised={false} />
                            )}
                        </>
                    )}
                </TableRow>
            )}
            <PreCheckRow title={messages.paymentOptionText} text={accountFrom} />
        </TableContainer>
    );
};
export default PreCheckDetails;
